<template>
  <div class="page-wrap DeviceList-page" ref="container">
		<Search :label="searchLabel" :dateFilter="false" @search="search" ref="search"></Search>
		<List title="物料列表" :refresh="true" :label="label" apiName="petMaterialList" ref="list"></List>
  </div>
</template>
<script>
import Search from "@components/Search";
import List from "@components/List";

export default {
  name: "PetAdminMaterialList",
  components: {
		Search,
		List,
  },
  props: {},
  data: function() {
    return {
      filter: {},
			searchLabel : [
				{field : 'machineCode', title : '设备编码'},
			],
			label : [
				{field : 'deviceSn', title : '设备编码'},
				{field : 'bodywash', title : '沐浴液余量'},
				{field : 'disinfectant', title : '消毒液余量'},
				{field : 'conditioner', title : '护毛素余量'},
				{field : 'btn', title : '物料配置', type : 'btn', click: this.moreInfo}
			],
    };
  },
  watch: {
    $route(n) {
      if (n.name === 'PetAdminMaterialList') {
    		let prevPage = this.$prevRoute();
    		if (prevPage && prevPage.name == "PetAdmin") {
    			this.$refs.search.reSet();
    			this.filter = {};
    			this.search(this.filter);
    		}
      }
    }
  },
  mounted: function() {
  },
  computed: {},
  methods: {
		search(filter) {
			this.filter = filter;
			this.$refs.list.reload(filter);
		},
		moreInfo(data) {
			this.$router.push({ path: "/petAdmin/stockConfig/" + data.deviceSn });
		}
  }
};
</script>
<style lang="scss">
body {background: #F9F9F9 !important;}
.page-wrap {
	padding: 0.3rem;
}
</style>
